import axios from 'axios';
import { plainToClass, Transform, Exclude, classToPlain, Type, Expose } from 'class-transformer';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var ConfManager = /** @class */ (function () {
    function ConfManager() {
    }
    ConfManager.getInstance = function () {
        if (!ConfManager.instance) {
            ConfManager.instance = new ConfManager();
        }
        return ConfManager.instance;
    };
    return ConfManager;
}());

/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });

var StorageManager = /** @class */ (function () {
    function StorageManager() {
    }
    StorageManager.set = function (key, value) {
        var useCookie = ConfManager.getInstance().useCookie;
        if (useCookie) {
            api.set(key, value, { expires: 365 });
        }
        else {
            localStorage.setItem(key, value);
        }
    };
    StorageManager.get = function (key) {
        var useCookie = ConfManager.getInstance().useCookie;
        if (useCookie) {
            return api.get(key);
        }
        else {
            return localStorage.getItem(key);
        }
    };
    StorageManager.remove = function (key) {
        var useCookie = ConfManager.getInstance().useCookie;
        if (useCookie) {
            api.remove(key);
        }
        else {
            localStorage.removeItem(key);
        }
    };
    return StorageManager;
}());

var BaseService = /** @class */ (function () {
    function BaseService(http) {
        this.http = http;
    }
    BaseService.prototype.mapResponse = function (httpResponse, entityClass) {
        return __awaiter(this, void 0, void 0, function () {
            var res, err_1, error, blob, blobText;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 5]);
                        return [4 /*yield*/, httpResponse];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, entityClass ? plainToClass(entityClass, res.data) : res.data];
                    case 2:
                        err_1 = _a.sent();
                        error = err_1;
                        if (!(error && error.config.responseType === 'blob')) return [3 /*break*/, 4];
                        if (!error.response) return [3 /*break*/, 4];
                        blob = error.response.data;
                        return [4 /*yield*/, blob.text()];
                    case 3:
                        blobText = _a.sent();
                        error.response.data = JSON.parse(blobText);
                        _a.label = 4;
                    case 4: throw error.response ? error.response : error;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return BaseService;
}());

var Factors;
(function (Factors) {
    Factors[Factors["DATE"] = 1000] = "DATE";
    Factors[Factors["CURRENCY"] = 100] = "CURRENCY";
})(Factors || (Factors = {}));
var MAX_TIME = 8640000000000000;
function capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
function newDate(time) {
    if (time === void 0) { time = false; }
    var d = new Date();
    if (!time) {
        d.setHours(0, 0, 0, 0);
    }
    return d;
}
function download(data, filename) {
    var url = URL.createObjectURL(data);
    var link = document.createElement('a');
    document.body.appendChild(link);
    link.href = url;
    link.target = '_blank';
    link.download = filename;
    link.click();
    setTimeout(function () {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }, 100);
}
function leftPad(s, size, char) {
    var pad = '';
    while ((pad.length + s.length) < size)
        pad += char;
    return pad + s;
}
function scrollToElement(el) {
    window.scroll(0, el.offsetTop);
}
function getValueByPath(obj, path) {
    return path.split('.').reduce(function (o, i) { return o[i]; }, obj);
}
function convertIntNumber(value) {
    if (typeof value === 'string')
        return parseInt(value.replace(/\./g, ''), 10);
    return value;
}
function convertFloatNumber(value) {
    if (typeof value === 'string')
        return parseFloat(value.replace(/\./g, ''));
    return value;
}
function num2Date(value) {
    return value ? new Date(value * Factors.DATE) : undefined;
}
function date2Num(value) {
    return value ? Math.round(value.getTime() / Factors.DATE) : undefined;
}
function cent2double(value) {
    return value !== null && typeof value !== 'undefined' ? value / Factors.CURRENCY : undefined;
}
function double2cent(value) {
    return value !== null && typeof value !== 'undefined' ? Math.round(value * Factors.CURRENCY) : undefined;
}
function num2Bool(value) {
    return !!value;
}
function bool2Num(value) {
    if (value === null)
        return 0;
    return value ? 1 : 0;
}
// type 0: toClass, 1 toPlain
function dateTransform(value, obj, type) {
    if (type === 0) {
        return num2Date(value);
    }
    else {
        return date2Num(value);
    }
}
// type 0: toClass, 1 toPlain
function centTransform(value, obj, type) {
    if (type === 0) {
        return cent2double(value);
    }
    else {
        return double2cent(value);
    }
}
// type 0: toClass, 1 toPlain
function booleanTransform(value, obj, type) {
    if (type === 0) {
        return num2Bool(value);
    }
    else {
        return bool2Num(value);
    }
}
function isNotBlank(value) {
    return typeof value !== 'undefined' && value !== null && value !== '';
}
function loadScript(url, id) {
    return new Promise(function (resolve, reject) {
        var existing = document.querySelector("script#" + id);
        if (existing) {
            resolve();
            return;
        }
        var script = document.createElement('script');
        script.onload = function () {
            resolve();
        };
        script.onerror = function (e) {
            reject(e);
        };
        script.id = id;
        script.async = false;
        script.src = url;
        script.type = 'text/javascript';
        document.head.appendChild(script);
    });
}
function getFileExtension(filename) {
    return filename && filename.includes('.') ? filename.substring(filename.lastIndexOf('.') + 1) : '';
}
function createCDNUrl(baseurl, basefolder, folder, eid, opaque, size, type) {
    if (type === void 0) { type = 'png'; }
    if (baseurl && eid && size && opaque) {
        if (!(baseurl === null || baseurl === void 0 ? void 0 : baseurl.endsWith('/'))) {
            baseurl = baseurl + '/';
        }
        if ((folder === null || folder === void 0 ? void 0 : folder.length) && !folder.endsWith('/')) {
            folder = folder + '/';
        }
        else if (!folder) {
            folder = '';
        }
        if ((basefolder === null || basefolder === void 0 ? void 0 : basefolder.length) && !basefolder.endsWith('/')) {
            basefolder = basefolder + '/';
        }
        else if (!basefolder) {
            basefolder = '';
        }
        return baseurl + basefolder + folder + eid + '/' + size + '/' + opaque + '.' + type;
    }
    else {
        return undefined;
    }
}

var InsDate = /** @class */ (function () {
    function InsDate() {
    }
    __decorate([
        Transform(dateTransform),
        __metadata("design:type", Date)
    ], InsDate.prototype, "insdate", void 0);
    return InsDate;
}());
var ModDate = /** @class */ (function () {
    function ModDate() {
    }
    __decorate([
        Transform(dateTransform),
        __metadata("design:type", Date)
    ], ModDate.prototype, "moddate", void 0);
    return ModDate;
}());
var InsModDate = /** @class */ (function (_super) {
    __extends(InsModDate, _super);
    function InsModDate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Transform(dateTransform),
        __metadata("design:type", Date)
    ], InsModDate.prototype, "moddate", void 0);
    return InsModDate;
}(InsDate));

var User = /** @class */ (function (_super) {
    __extends(User, _super);
    function User() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Exclude({ toPlainOnly: true }),
        __metadata("design:type", String)
    ], User.prototype, "token", void 0);
    return User;
}(InsModDate));
var Usertorole = /** @class */ (function (_super) {
    __extends(Usertorole, _super);
    function Usertorole() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Usertorole;
}(InsDate));
var Gender;
(function (Gender) {
    Gender["MALE"] = "M";
    Gender["FEMALE"] = "F";
})(Gender || (Gender = {}));

var AuthService = /** @class */ (function (_super) {
    __extends(AuthService, _super);
    function AuthService(http) {
        var _this = _super.call(this, http) || this;
        _this.TOKEN_COOKIE = ConfManager.getInstance().tokenCookie;
        _this.USER_COOKIE = ConfManager.getInstance().userCookie;
        _this.LOGIN_PATH = ConfManager.getInstance().loginPath;
        _this.USER_PATH = ConfManager.getInstance().userPath;
        return _this;
    }
    AuthService.prototype.login = function (login) {
        return __awaiter(this, void 0, void 0, function () {
            var token, httpOptions, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAnonymousToken()];
                    case 1:
                        token = _a.sent();
                        httpOptions = {
                            headers: {
                                'Authorization': "Bearer " + token.jwt
                            }
                        };
                        return [4 /*yield*/, this.mapResponse(this.http.post("/ws/" + this.LOGIN_PATH, classToPlain(login), httpOptions), User)];
                    case 2:
                        user = _a.sent();
                        StorageManager.set(this.TOKEN_COOKIE, user.token);
                        StorageManager.set(this.USER_COOKIE, user.id.toString());
                        return [2 /*return*/, user];
                }
            });
        });
    };
    AuthService.prototype.getAnonymousToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.mapResponse(this.http.get('/ws/jwt/token', {}))];
            });
        });
    };
    AuthService.prototype.getLoggedUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, id;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = StorageManager.get(this.USER_COOKIE);
                        id = +user;
                        return [4 /*yield*/, this.getUser(id)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthService.prototype.logout = function () {
        StorageManager.remove(this.TOKEN_COOKIE);
        StorageManager.remove(this.USER_COOKIE);
    };
    AuthService.prototype.getToken = function () {
        return StorageManager.get(this.TOKEN_COOKIE);
    };
    AuthService.prototype.getUid = function () {
        return StorageManager.get(this.USER_COOKIE);
    };
    AuthService.prototype.getUser = function (id) {
        return this.mapResponse(this.http.get("/ws/" + this.USER_PATH + "/" + id));
    };
    return AuthService;
}(BaseService));

var http = axios.create({});
http.interceptors.request.use(function (config) {
    var conf = ConfManager.getInstance();
    if (conf.apiUrl) {
        config.baseURL = conf.apiUrl;
    }
    if (!config.headers['Authorization']) {
        var token = StorageManager.get(conf.tokenCookie);
        if (token) {
            config.headers['Authorization'] = "Bearer " + token;
        }
    }
    var globalHeaders = conf.globalHeaders;
    if (globalHeaders) {
        globalHeaders.forEach(function (header) { return config.headers[header.key] = header.value; });
    }
    if (conf.apiI18n) {
        var lang = StorageManager.get(conf.i18nCookie);
        if (lang) {
            config.headers['Yellowfin-Lang'] = lang;
        }
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});
http.interceptors.response.use(function (response) {
    return response;
}, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var status, authService, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                status = error.request.status;
                if (!(status === 401)) return [3 /*break*/, 3];
                authService = new AuthService(http);
                return [4 /*yield*/, authService.getAnonymousToken()];
            case 1:
                token = _a.sent();
                error.config.headers['Authorization'] = '';
                StorageManager.set(ConfManager.getInstance().tokenCookie, token.jwt);
                return [4 /*yield*/, http.request(error.config)];
            case 2: return [2 /*return*/, _a.sent()];
            case 3: return [2 /*return*/, Promise.reject(error)];
        }
    });
}); });

var Attach = /** @class */ (function () {
    function Attach() {
    }
    __decorate([
        Transform(dateTransform),
        __metadata("design:type", Date)
    ], Attach.prototype, "uploaddate", void 0);
    __decorate([
        Exclude(),
        __metadata("design:type", Object)
    ], Attach.prototype, "previewurl", void 0);
    return Attach;
}());

var Comune = /** @class */ (function () {
    function Comune() {
    }
    return Comune;
}());

var Conf = /** @class */ (function (_super) {
    __extends(Conf, _super);
    function Conf() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Transform(booleanTransform),
        __metadata("design:type", Boolean)
    ], Conf.prototype, "overridable", void 0);
    return Conf;
}(InsModDate));

var Feature = /** @class */ (function () {
    function Feature() {
    }
    Feature.prototype.filter = function (filter) {
        return !filter || !this.name || this.name.toLowerCase().includes(filter.toLowerCase());
    };
    Feature.prototype.isInSection = function (section) {
        var s = section.getSection();
        if (s) {
            return this.slug.startsWith(s + '.');
        }
        else {
            return false;
        }
    };
    Feature.prototype.getSection = function () {
        if (this.slug.includes('section.')) {
            return this.slug.replace('section.', '');
        }
        else {
            return undefined;
        }
    };
    return Feature;
}());

var Listitem = /** @class */ (function () {
    function Listitem() {
    }
    return Listitem;
}());

var List = /** @class */ (function () {
    function List() {
    }
    __decorate([
        Exclude({ toPlainOnly: true }),
        Transform(function () { return Listitem; }),
        __metadata("design:type", Array)
    ], List.prototype, "items", void 0);
    return List;
}());

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var md5 = createCommonjsModule(function (module, exports) {
/*

TypeScript Md5
==============

Based on work by
* Joseph Myers: http://www.myersdaily.org/joseph/javascript/md5-text.html
* André Cruz: https://github.com/satazor/SparkMD5
* Raymond Hill: https://github.com/gorhill/yamd5.js

Effectively a TypeScrypt re-write of Raymond Hill JS Library

The MIT License (MIT)

Copyright (C) 2014 Raymond Hill

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.



            DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
                    Version 2, December 2004

 Copyright (C) 2015 André Cruz <amdfcruz@gmail.com>

 Everyone is permitted to copy and distribute verbatim or modified
 copies of this license document, and changing it is allowed as long
 as the name is changed.

            DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
   TERMS AND CONDITIONS FOR COPYING, DISTRIBUTION AND MODIFICATION

  0. You just DO WHAT THE FUCK YOU WANT TO.


*/
Object.defineProperty(exports, "__esModule", { value: true });
var Md5 = /** @class */ (function () {
    function Md5() {
        this._state = new Int32Array(4);
        this._buffer = new ArrayBuffer(68);
        this._buffer8 = new Uint8Array(this._buffer, 0, 68);
        this._buffer32 = new Uint32Array(this._buffer, 0, 17);
        this.start();
    }
    // One time hashing functions
    Md5.hashStr = function (str, raw) {
        if (raw === void 0) { raw = false; }
        return this.onePassHasher
            .start()
            .appendStr(str)
            .end(raw);
    };
    Md5.hashAsciiStr = function (str, raw) {
        if (raw === void 0) { raw = false; }
        return this.onePassHasher
            .start()
            .appendAsciiStr(str)
            .end(raw);
    };
    Md5._hex = function (x) {
        var hc = Md5.hexChars;
        var ho = Md5.hexOut;
        var n;
        var offset;
        var j;
        var i;
        for (i = 0; i < 4; i += 1) {
            offset = i * 8;
            n = x[i];
            for (j = 0; j < 8; j += 2) {
                ho[offset + 1 + j] = hc.charAt(n & 0x0F);
                n >>>= 4;
                ho[offset + 0 + j] = hc.charAt(n & 0x0F);
                n >>>= 4;
            }
        }
        return ho.join('');
    };
    Md5._md5cycle = function (x, k) {
        var a = x[0];
        var b = x[1];
        var c = x[2];
        var d = x[3];
        // ff()
        a += (b & c | ~b & d) + k[0] - 680876936 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[1] - 389564586 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[2] + 606105819 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[4] - 176418897 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[7] - 45705983 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[10] - 42063 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[13] - 40341101 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        // gg()
        a += (b & d | c & ~d) + k[1] - 165796510 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[11] + 643717713 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[0] - 373897302 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[5] - 701558691 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[10] + 38016083 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[15] - 660478335 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[4] - 405537848 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[9] + 568446438 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[3] - 187363961 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[2] - 51403784 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        // hh()
        a += (b ^ c ^ d) + k[5] - 378558 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[14] - 35309556 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[7] - 155497632 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[13] + 681279174 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[0] - 358537222 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[3] - 722521979 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[6] + 76029189 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[9] - 640364487 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[12] - 421815835 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[15] + 530742520 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[2] - 995338651 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        // ii()
        a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        x[0] = a + x[0] | 0;
        x[1] = b + x[1] | 0;
        x[2] = c + x[2] | 0;
        x[3] = d + x[3] | 0;
    };
    Md5.prototype.start = function () {
        this._dataLength = 0;
        this._bufferLength = 0;
        this._state.set(Md5.stateIdentity);
        return this;
    };
    // Char to code point to to array conversion:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/charCodeAt
    // #Example.3A_Fixing_charCodeAt_to_handle_non-Basic-Multilingual-Plane_characters_if_their_presence_earlier_in_the_string_is_unknown
    Md5.prototype.appendStr = function (str) {
        var buf8 = this._buffer8;
        var buf32 = this._buffer32;
        var bufLen = this._bufferLength;
        var code;
        var i;
        for (i = 0; i < str.length; i += 1) {
            code = str.charCodeAt(i);
            if (code < 128) {
                buf8[bufLen++] = code;
            }
            else if (code < 0x800) {
                buf8[bufLen++] = (code >>> 6) + 0xC0;
                buf8[bufLen++] = code & 0x3F | 0x80;
            }
            else if (code < 0xD800 || code > 0xDBFF) {
                buf8[bufLen++] = (code >>> 12) + 0xE0;
                buf8[bufLen++] = (code >>> 6 & 0x3F) | 0x80;
                buf8[bufLen++] = (code & 0x3F) | 0x80;
            }
            else {
                code = ((code - 0xD800) * 0x400) + (str.charCodeAt(++i) - 0xDC00) + 0x10000;
                if (code > 0x10FFFF) {
                    throw new Error('Unicode standard supports code points up to U+10FFFF');
                }
                buf8[bufLen++] = (code >>> 18) + 0xF0;
                buf8[bufLen++] = (code >>> 12 & 0x3F) | 0x80;
                buf8[bufLen++] = (code >>> 6 & 0x3F) | 0x80;
                buf8[bufLen++] = (code & 0x3F) | 0x80;
            }
            if (bufLen >= 64) {
                this._dataLength += 64;
                Md5._md5cycle(this._state, buf32);
                bufLen -= 64;
                buf32[0] = buf32[16];
            }
        }
        this._bufferLength = bufLen;
        return this;
    };
    Md5.prototype.appendAsciiStr = function (str) {
        var buf8 = this._buffer8;
        var buf32 = this._buffer32;
        var bufLen = this._bufferLength;
        var i;
        var j = 0;
        for (;;) {
            i = Math.min(str.length - j, 64 - bufLen);
            while (i--) {
                buf8[bufLen++] = str.charCodeAt(j++);
            }
            if (bufLen < 64) {
                break;
            }
            this._dataLength += 64;
            Md5._md5cycle(this._state, buf32);
            bufLen = 0;
        }
        this._bufferLength = bufLen;
        return this;
    };
    Md5.prototype.appendByteArray = function (input) {
        var buf8 = this._buffer8;
        var buf32 = this._buffer32;
        var bufLen = this._bufferLength;
        var i;
        var j = 0;
        for (;;) {
            i = Math.min(input.length - j, 64 - bufLen);
            while (i--) {
                buf8[bufLen++] = input[j++];
            }
            if (bufLen < 64) {
                break;
            }
            this._dataLength += 64;
            Md5._md5cycle(this._state, buf32);
            bufLen = 0;
        }
        this._bufferLength = bufLen;
        return this;
    };
    Md5.prototype.getState = function () {
        var self = this;
        var s = self._state;
        return {
            buffer: String.fromCharCode.apply(null, self._buffer8),
            buflen: self._bufferLength,
            length: self._dataLength,
            state: [s[0], s[1], s[2], s[3]]
        };
    };
    Md5.prototype.setState = function (state) {
        var buf = state.buffer;
        var x = state.state;
        var s = this._state;
        var i;
        this._dataLength = state.length;
        this._bufferLength = state.buflen;
        s[0] = x[0];
        s[1] = x[1];
        s[2] = x[2];
        s[3] = x[3];
        for (i = 0; i < buf.length; i += 1) {
            this._buffer8[i] = buf.charCodeAt(i);
        }
    };
    Md5.prototype.end = function (raw) {
        if (raw === void 0) { raw = false; }
        var bufLen = this._bufferLength;
        var buf8 = this._buffer8;
        var buf32 = this._buffer32;
        var i = (bufLen >> 2) + 1;
        var dataBitsLen;
        this._dataLength += bufLen;
        buf8[bufLen] = 0x80;
        buf8[bufLen + 1] = buf8[bufLen + 2] = buf8[bufLen + 3] = 0;
        buf32.set(Md5.buffer32Identity.subarray(i), i);
        if (bufLen > 55) {
            Md5._md5cycle(this._state, buf32);
            buf32.set(Md5.buffer32Identity);
        }
        // Do the final computation based on the tail and length
        // Beware that the final length may not fit in 32 bits so we take care of that
        dataBitsLen = this._dataLength * 8;
        if (dataBitsLen <= 0xFFFFFFFF) {
            buf32[14] = dataBitsLen;
        }
        else {
            var matches = dataBitsLen.toString(16).match(/(.*?)(.{0,8})$/);
            if (matches === null) {
                return;
            }
            var lo = parseInt(matches[2], 16);
            var hi = parseInt(matches[1], 16) || 0;
            buf32[14] = lo;
            buf32[15] = hi;
        }
        Md5._md5cycle(this._state, buf32);
        return raw ? this._state : Md5._hex(this._state);
    };
    // Private Static Variables
    Md5.stateIdentity = new Int32Array([1732584193, -271733879, -1732584194, 271733878]);
    Md5.buffer32Identity = new Int32Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    Md5.hexChars = '0123456789abcdef';
    Md5.hexOut = [];
    // Permanent instance is to use for one-call hashing
    Md5.onePassHasher = new Md5();
    return Md5;
}());
exports.Md5 = Md5;
if (Md5.hashStr('hello') !== '5d41402abc4b2a76b9719d911017c592') {
    console.error('Md5 self test failed.');
}

});

unwrapExports(md5);
var md5_1 = md5.Md5;

var Login = /** @class */ (function () {
    function Login() {
        this.vapp = '0.0.1';
        this.pushid = 'xxxxxxxxxxxx';
        this.imsi = '123432343234';
        this.os = 'web';
        this.vos = '5.0';
        this.device = 'web';
    }
    Object.defineProperty(Login.prototype, "md5password", {
        set: function (pass) {
            this.password = md5_1.hashStr(pass);
        },
        enumerable: true,
        configurable: true
    });
    return Login;
}());

var Page = /** @class */ (function () {
    function Page(size) {
        if (size === void 0) { size = 20; }
        // The number of elements in the page
        this.size = 0;
        this.sizeMore = 0;
        // The total number of elements
        this.totalElements = 0;
        // The total number of pages
        this.totalPages = 0;
        // The current page number
        this.pageNumber = 0;
        this.start = 0;
        this.stop = 0;
        this.setSize(size);
    }
    Page.prototype.setPageNumber = function (n, elementsPerRow) {
        if (elementsPerRow === void 0) { elementsPerRow = 1; }
        this.pageNumber = n;
        this.start = this.pageNumber * this.size * elementsPerRow;
        this.stop = this.start + this.size * elementsPerRow;
    };
    Page.prototype.setTotal = function (t) {
        this.totalElements = t;
        this.totalPages = Math.ceil(t / this.size);
    };
    Page.prototype.setSize = function (size) {
        this.sizeMore = 0;
        this.size = size;
        this.stop = this.start + this.size;
    };
    Page.prototype.setSizeMore = function (size) {
        this.sizeMore = size;
        this.stop = this.start + this.size;
    };
    return Page;
}());

var Provincia = /** @class */ (function () {
    function Provincia() {
    }
    return Provincia;
}());

var Regione = /** @class */ (function () {
    function Regione() {
    }
    return Regione;
}());

var Role = /** @class */ (function (_super) {
    __extends(Role, _super);
    function Role() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Exclude({ toPlainOnly: true }),
        __metadata("design:type", String)
    ], Role.prototype, "slug", void 0);
    __decorate([
        Exclude(),
        __metadata("design:type", Array)
    ], Role.prototype, "features", void 0);
    __decorate([
        Exclude(),
        __metadata("design:type", Boolean)
    ], Role.prototype, "showdetails", void 0);
    return Role;
}(InsModDate));
var RoleFeature = /** @class */ (function (_super) {
    __extends(RoleFeature, _super);
    function RoleFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Type(function () { return Feature; }),
        __metadata("design:type", Feature)
    ], RoleFeature.prototype, "feature", void 0);
    return RoleFeature;
}(InsDate));

var Search = /** @class */ (function () {
    function Search(table, pageid) {
        this.simpleTmp = {};
        this.likeTmp = {};
        this.rangeTmp = {};
        this.notEqualTmp = {};
        this.inTmp = {};
        this.notInTmp = {};
        this.orTmp = [];
        this.genericTmp = {};
        this.page = new Page();
        this.table = table;
        this.pageid = pageid;
    }
    Search.prototype.reset = function () {
        var _this = this;
        this.simpleTmp = {};
        this.likeTmp = {};
        this.rangeTmp = {};
        this.notEqualTmp = {};
        this.inTmp = {};
        this.notInTmp = {};
        this.orTmp = [];
        // this.notOrTmp = [];
        Object.keys(this.genericTmp).forEach(function (key) {
            _this[key] = undefined;
        });
    };
    Search.prototype.resetSort = function () {
        this.sortField = undefined;
        this.sortDirection = undefined;
    };
    Search.prototype.addSimpleFilter = function (field, value, unsensitive, type) {
        if (unsensitive === void 0) { unsensitive = false; }
        this.simpleTmp[field] = { value: value, unsensitive: unsensitive, type: type };
    };
    Search.prototype.addLikeFilter = function (field, value, unsensitive, logic) {
        if (unsensitive === void 0) { unsensitive = false; }
        this.likeTmp[field] = { value: value, logic: logic, unsensitive: unsensitive };
    };
    Search.prototype.addRangeFilter = function (field, start, stop, type) {
        this.rangeTmp[field] = { start: start, stop: stop, type: type };
    };
    Search.prototype.addNotEqualFilter = function (field, value, unsensitive, type) {
        if (unsensitive === void 0) { unsensitive = false; }
        this.notEqualTmp[field] = { value: value, unsensitive: unsensitive, type: type };
    };
    Search.prototype.addInFilter = function (field, value, unsensitive, type) {
        if (unsensitive === void 0) { unsensitive = false; }
        this.inTmp[field] = { value: value, unsensitive: unsensitive, type: type };
    };
    Search.prototype.addNotInFilter = function (field, value, unsensitive, type) {
        if (unsensitive === void 0) { unsensitive = false; }
        this.notInTmp[field] = { value: value, unsensitive: unsensitive, type: type };
    };
    Search.prototype.addGenericFilter = function (field, value) {
        this[field] = value;
        this.genericTmp[field] = value;
    };
    Search.prototype.addOrFilter = function (fields, filter, unsensitive, like, type) {
        if (unsensitive === void 0) { unsensitive = false; }
        if (like === void 0) { like = false; }
        this.orTmp.push({ fields: fields, filter: filter, unsensitive: unsensitive, like: like, type: type });
    };
    Search.prototype.addOrFilters = function (field, filters, unsensitive, like, type) {
        if (unsensitive === void 0) { unsensitive = false; }
        if (like === void 0) { like = false; }
        this.orTmp.push({ fields: [field], filters: filters, unsensitive: unsensitive, like: like, type: type });
    };
    Search.prototype.setSortField = function (field) {
        this.sortField = field;
    };
    Search.prototype.setSortDirection = function (direction) {
        this.sortDirection = direction;
    };
    Search.prototype.removeSimpleFilter = function (field) {
        this.simpleTmp[field] = undefined;
        delete this.simpleTmp[field];
    };
    Search.prototype.removeLikeFilter = function (field) {
        this.likeTmp[field] = undefined;
        delete this.likeTmp[field];
    };
    Search.prototype.removeRangeFilter = function (field) {
        this.rangeTmp[field] = undefined;
        delete this.rangeTmp[field];
    };
    Search.prototype.removeOrFilter = function (field) {
        var index = -1;
        for (var i = 0; i < this.orTmp.length; i++) {
            if (this.orTmp[i].fields[0] === field) {
                index = i;
                break;
            }
        }
        if (index >= 0) {
            this.orTmp.splice(index, 1);
        }
    };
    __decorate([
        Expose({ name: 'simple' }),
        Transform(prepareSimple, { toPlainOnly: true }),
        __metadata("design:type", Object)
    ], Search.prototype, "simpleTmp", void 0);
    __decorate([
        Expose({ name: 'like' }),
        Transform(prepareLike, { toPlainOnly: true }),
        __metadata("design:type", Object)
    ], Search.prototype, "likeTmp", void 0);
    __decorate([
        Expose({ name: 'range' }),
        Transform(prepareRange, { toPlainOnly: true }),
        __metadata("design:type", Object)
    ], Search.prototype, "rangeTmp", void 0);
    __decorate([
        Expose({ name: 'notequal' }),
        Transform(prepareNotEqual, { toPlainOnly: true }),
        __metadata("design:type", Object)
    ], Search.prototype, "notEqualTmp", void 0);
    __decorate([
        Expose({ name: 'in' }),
        Transform(prepareIn, { toPlainOnly: true }),
        __metadata("design:type", Object)
    ], Search.prototype, "inTmp", void 0);
    __decorate([
        Expose({ name: 'notin' }),
        Transform(prepareNotIn, { toPlainOnly: true }),
        __metadata("design:type", Object)
    ], Search.prototype, "notInTmp", void 0);
    __decorate([
        Expose({ name: 'or' }),
        Transform(prepareOr, { toPlainOnly: true }),
        __metadata("design:type", Object)
    ], Search.prototype, "orTmp", void 0);
    __decorate([
        Exclude(),
        __metadata("design:type", Object)
    ], Search.prototype, "genericTmp", void 0);
    __decorate([
        Expose({ name: 'sortfield' }),
        __metadata("design:type", String)
    ], Search.prototype, "sortField", void 0);
    __decorate([
        Expose({ name: 'direction' }),
        __metadata("design:type", String)
    ], Search.prototype, "sortDirection", void 0);
    __decorate([
        Exclude(),
        __metadata("design:type", String)
    ], Search.prototype, "pageid", void 0);
    __decorate([
        Exclude(),
        __metadata("design:type", Page)
    ], Search.prototype, "page", void 0);
    return Search;
}());
var SortDirection;
(function (SortDirection) {
    SortDirection["ASCENDING"] = "asc";
    SortDirection["DESCENDING"] = "desc";
})(SortDirection || (SortDirection = {}));
var RangeFilter = /** @class */ (function () {
    function RangeFilter() {
    }
    return RangeFilter;
}());
function prepareRange(value) {
    var output = Object.keys(value).map(function (key) {
        var v = value[key];
        return {
            field: key,
            start: v.start,
            stop: v.stop,
            type: v.type ? v.type : undefined
        };
    });
    return output;
}
function prepareSimple(value) {
    var output = Object.keys(value).map(function (key) {
        var v = value[key];
        return {
            field: key,
            filter: v.value,
            unsensitive: v.unsensitive,
            type: v.type
        };
    });
    return output;
}
function prepareLike(value) {
    var output = Object.keys(value).map(function (key) {
        var v = value[key];
        return {
            field: key,
            term: v.value,
            logic: v.logic,
            unsensitive: v.unsensitive
        };
    });
    return output;
}
function prepareNotEqual(value) {
    var output = Object.keys(value).map(function (key) {
        var v = value[key];
        return {
            field: key,
            filter: v.value,
            unsensitive: v.unsensitive,
            type: v.type
        };
    });
    return output;
}
function prepareIn(value) {
    var output = Object.keys(value).map(function (key) {
        var v = value[key];
        return {
            field: key,
            filter: v.value.join(';'),
            unsensitive: v.unsensitive,
            type: v.type
        };
    });
    return output;
}
function prepareNotIn(value) {
    var output = Object.keys(value).map(function (key) {
        var v = value[key];
        return {
            field: key,
            filter: v.value.join(';'),
            unsensitive: v.unsensitive,
            type: v.type
        };
    });
    return output;
}
function prepareOr(value) {
    var filterd = value.filter(function (v) { return !v.length; });
    var output = Object.keys(filterd).map(function (key) {
        var v = value[key];
        return {
            fields: key,
            filter: v,
        };
    });
    return output;
}

var SystemFeature = /** @class */ (function (_super) {
    __extends(SystemFeature, _super);
    function SystemFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SystemFeature;
}(InsDate));

var Count = /** @class */ (function () {
    function Count() {
    }
    return Count;
}());

var Token = /** @class */ (function () {
    function Token() {
    }
    return Token;
}());

var CrudService = /** @class */ (function (_super) {
    __extends(CrudService, _super);
    function CrudService(http) {
        return _super.call(this, http) || this;
    }
    CrudService.prototype.getAll = function (entityClass, entityName, extraRest) {
        var url = !extraRest ? "/ws/" + entityName : "/ws/" + entityName + "/" + extraRest;
        return this.mapResponse(this.http.get(url), entityClass);
    };
    CrudService.prototype.getCount = function (entityClass, entityName) {
        return this.mapResponse(this.http.get("/ws/" + entityName + "/count"), entityClass);
    };
    CrudService.prototype.getEntity = function (entityClass, entityName, id) {
        return this.mapResponse(this.http.get("/ws/" + entityName + "/" + id), entityClass);
    };
    CrudService.prototype.saveEntity = function (entityClass, entityName, entity) {
        return this.mapResponse(this.http.put("/ws/" + entityName + "/" + entity.id, classToPlain(entity)), entityClass);
    };
    CrudService.prototype.createEntity = function (entityClass, entityName, entity) {
        return this.mapResponse(this.http.post("/ws/" + entityName, classToPlain(entity)), entityClass);
    };
    CrudService.prototype.deleteEntity = function (entityClass, entityName, entity) {
        return this.mapResponse(this.http.delete("/ws/" + entityName + "/" + entity.id), entityClass);
    };
    CrudService.prototype.searchEntities = function (entityClass, entityName, search, page) {
        return this.mapResponse(this.http.post("/ws/" + entityName + "/advancedsearch/" + page.start + "/" + page.stop, classToPlain(search)), entityClass);
    };
    CrudService.prototype.countEntities = function (entityClass, entityName, search) {
        return this.mapResponse(this.http.post("/ws/" + entityName + "/advancedcount", classToPlain(search)), entityClass);
    };
    return CrudService;
}(BaseService));

var AttachService = /** @class */ (function (_super) {
    __extends(AttachService, _super);
    function AttachService(http) {
        return _super.call(this, http) || this;
    }
    AttachService.prototype.download = function (opaqueid) {
        return this.mapResponse(this.http.get("/ws/download/x/" + opaqueid, { responseType: 'blob' }));
    };
    AttachService.prototype.downloadBySize = function (opaqueid, size) {
        return this.mapResponse(this.http.get("/ws/download/x/" + opaqueid + "/" + size, { responseType: 'blob' }));
    };
    AttachService.prototype.downloadByScaleto = function (opaqueid, size) {
        return this.mapResponse(this.http.get("/ws/download/x/" + opaqueid + "/scaleto/" + size, { responseType: 'blob' }));
    };
    AttachService.prototype.upload = function (entity, eid, file, uploadProgress) {
        var formData = new FormData();
        formData.append('file', file);
        return this.mapResponse(this.http.post("/ws/upload/" + entity + "/" + eid, formData, {
            onUploadProgress: uploadProgress
        }));
    };
    return AttachService;
}(BaseService));

var ServiceContainer = /** @class */ (function () {
    function ServiceContainer() {
        this.services = {};
    }
    ServiceContainer.prototype.set = function (key, service) {
        this.services[key] = service;
    };
    ServiceContainer.prototype.get = function (key) {
        return this.getInstance(key);
    };
    ServiceContainer.prototype.getAll = function () {
        var _this = this;
        var o = {};
        Object.keys(this.services).forEach(function (k) {
            Object.defineProperty(o, k, {
                enumerable: true,
                get: function () { return _this.getInstance(k); },
            });
        });
        return o;
    };
    ServiceContainer.prototype.getInstance = function (key) {
        return new this.services[key](http);
    };
    return ServiceContainer;
}());

export { Attach, AttachService, AuthService, BaseService, Comune, Conf, ConfManager, Count, CrudService, Factors, Feature, Gender, http as HttpClient, InsDate, InsModDate, List, Listitem, Login, MAX_TIME, ModDate, Page, Provincia, RangeFilter, Regione, Role, RoleFeature, Search, ServiceContainer, SortDirection, StorageManager, SystemFeature, Token, User, Usertorole, bool2Num, booleanTransform, capitalize, cent2double, centTransform, convertFloatNumber, convertIntNumber, createCDNUrl, date2Num, dateTransform, double2cent, download, getFileExtension, getValueByPath, isNotBlank, leftPad, loadScript, newDate, num2Bool, num2Date, scrollToElement };
//# sourceMappingURL=index.esm.js.map
